module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-policy-button"
  }, [_c('div', {
    staticClass: "dropdown-buttons"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'federation-vehicles',
        params: {
          id: _vm.item.id
        }
      }
    }
  }, [_vm._v("Vehicles")]), _c('router-link', {
    attrs: {
      "to": {
        name: 'federation-parking-groups',
        params: {
          id: _vm.item.id
        }
      }
    }
  }, [_vm._v("Parking groups")]), _c('router-link', {
    attrs: {
      "to": {
        name: 'federation-clients',
        params: {
          id: _vm.item.id
        }
      }
    }
  }, [_vm._v("Clients")]), _c('ActionButton', {
    attrs: {
      "action": _vm.remove,
      "confirm": true
    }
  }, [_vm._v("Delete")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-42c618dc!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/actions/FederationButtons.vue
// module id = 2448
// module chunks = 1